<template>
  <NfFormItem icon="header" :label="label">
    <div class="header-wrapper" slot="right">
      <img :src="value || userHeader" class="img-response" />
    </div>
  </NfFormItem>
</template>

<script>
import NfFormItem from "./NfFormItem"
const DEFAULT_HEADER = require("@/assets/images/head_moren.png")

export default {
  name: "uiFormItenName",
  props: {
    value: {
      type: String,
      default: DEFAULT_HEADER
    },
    label: {
      type: String,
      default: "头像"
    }
  },
  components: {
    NfFormItem
  },
  computed: {
    userHeader() {
      return DEFAULT_HEADER
    }
  }
}
</script>

<style lang="scss" scoped>
.header-wrapper {
  width: 0.46rem;
  height: 0.46rem;
  overflow: hidden;
  border-radius: 50%;
}
.img-response {
  display: block;
  height: 100%;
  width: 100%;
  object-fit: contain;
}
</style>
